/* eslint-disable require-yield */
import { GaPageGroups } from '../../constants';
import { trackGaPageView, trackGaView } from '../../utils';

export function* onLocationChange(action) {
  trackGaPageView(action.payload.pathname);
}

export function* onOpenSessionHistory() {
  trackGaView(GaPageGroups.SESSION_HISTORY);
}

export function* onCloseSessionHistory({ payload }) {
  if (!payload.isLeavingNowPlaying) {
    trackGaView(GaPageGroups.NOW_PLAYING);
  }
}
